import { AxiosInstance } from "axios";

const FIFTEEN_SECONDS = 1000 * 15;

export const addTimeoutInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(function (config) {
    config.timeout = FIFTEEN_SECONDS;
    return config;
  });
};
